import { useEffect, useState } from 'react'

import { Calendar } from '@/components/ui/calendar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { cn } from '@/lib/utils'

import { format } from 'date-fns'
import { CalendarIcon } from 'lucide-react'
import { Button } from '../ui/button'
import { DatePickerProps } from './@types'

export function DatePicker({ onChange, label, defaultDate }: DatePickerProps) {
  const [open, setOpen] = useState(false)
  const [date, setDate] = useState<Date | undefined>(
    defaultDate ? new Date(defaultDate) : undefined,
  )

  useEffect(() => {
    setOpen(false)
    onChange(date?.toISOString())

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date])

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            'w-max max-w-[280px] justify-start text-left font-normal',
            date && 'border-primary text-primary',
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? format(date, 'dd/MM/yyyy') : <span>{label}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={setDate}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  )
}
